import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from '@caruso/ui';
import { Router } from './Router';
import { CartProvider } from './contexts/cart-context';
import { ClientAuthProvider } from './contexts/client-auth-context';
import { ThemeProvider } from './contexts/theme-context';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <BrowserRouter>
          <ClientAuthProvider>
            <CartProvider>
              <Router />
              <Toaster />
            </CartProvider>
          </ClientAuthProvider>
        </BrowserRouter>
      </ThemeProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}